import { logDidYouMeanClick } from '../did-you-mean/did-you-mean-analytics-actions.js';
import { logCategoryFacetBreadcrumb, } from '../facets/category-facet-set/category-facet-set-analytics-actions.js';
import { logFacetBreadcrumb, logFacetClearAll, logFacetUnexclude, logFacetExclude, logFacetDeselect, logFacetSelect, logFacetShowLess, logFacetShowMore, logFacetUpdateSort, } from '../facets/facet-set/facet-set-analytics-actions.js';
import { logClearBreadcrumbs } from '../facets/generic/facet-generic-analytics-actions.js';
import { logDateFacetBreadcrumb, } from '../facets/range-facets/date-facet-set/date-facet-analytics-actions.js';
import { logNumericFacetBreadcrumb, } from '../facets/range-facets/numeric-facet-set/numeric-facet-analytics-actions.js';
import { logNavigateBackward, logNavigateForward, logNoResultsBack, } from '../history/history-analytics-actions.js';
import { logPageNext, logPageNumber, logPagePrevious, logPagerResize, } from '../pagination/pagination-analytics-actions.js';
import { logQuerySuggestionClick, } from '../query-suggest/query-suggest-analytics-actions.js';
import { logSearchboxSubmit } from '../query/query-analytics-actions.js';
import { logCollapseSmartSnippet, logExpandSmartSnippet, logDislikeSmartSnippet, logLikeSmartSnippet, logOpenSmartSnippetFeedbackModal, logCloseSmartSnippetFeedbackModal, logSmartSnippetFeedback, logSmartSnippetDetailedFeedback, logCollapseSmartSnippetSuggestion, logExpandSmartSnippetSuggestion, } from '../question-answering/question-answering-analytics-actions.js';
import { logResultsSort } from '../sort-criteria/sort-criteria-analytics-actions.js';
import { logStaticFilterSelect, logStaticFilterDeselect, logStaticFilterClearAll, } from '../static-filter-set/static-filter-set-actions.js';
import { logNotifyTrigger, logTriggerExecute, logTriggerQuery, logTriggerRedirect, logUndoTriggerQuery, } from '../triggers/trigger-analytics-actions.js';
import { logInterfaceChange, logInterfaceLoad, logSearchFromLink, logOmniboxFromLink, } from './analytics-actions.js';
/**
 * Returns possible search analytics action creators.
 *
 * @param engine - The headless engine.
 * @returns An object holding the action creators.
 *
 * @group Actions
 * @category Analytics
 */
export function loadSearchAnalyticsActions(engine) {
    engine.addReducers({});
    return {
        logClearBreadcrumbs,
        logInterfaceLoad,
        logSearchFromLink,
        logOmniboxFromLink,
        logInterfaceChange,
        logDidYouMeanClick,
        logCategoryFacetBreadcrumb,
        logFacetBreadcrumb,
        logFacetClearAll,
        logFacetUnexclude,
        logFacetExclude,
        logFacetDeselect,
        logFacetSelect,
        logFacetShowLess,
        logFacetShowMore,
        logFacetUpdateSort,
        logDateFacetBreadcrumb,
        logNumericFacetBreadcrumb,
        logNavigateBackward,
        logNavigateForward,
        logPageNext,
        logPageNumber,
        logPagePrevious,
        logPagerResize,
        logSearchboxSubmit,
        logQuerySuggestionClick,
        logResultsSort,
        logDislikeSmartSnippet,
        logLikeSmartSnippet,
        logOpenSmartSnippetFeedbackModal,
        logCloseSmartSnippetFeedbackModal,
        logSmartSnippetFeedback,
        logSmartSnippetDetailedFeedback,
        logExpandSmartSnippet,
        logCollapseSmartSnippet,
        logExpandSmartSnippetSuggestion,
        logCollapseSmartSnippetSuggestion,
        logNoResultsBack,
        logStaticFilterSelect,
        logStaticFilterDeselect,
        logStaticFilterClearAll,
        logTriggerQuery,
        logUndoTriggerQuery,
        logNotifyTrigger,
        logTriggerRedirect,
        logTriggerExecute,
    };
}
